<template>
    <teleport to="body">
        <transition name="fm-lightbox">
            <div v-if="visible" class="fm-lightbox" @click="close" @keydown="onKeyDown" tabindex="0" ref="lightbox">
                <button class="fm-lightbox-close" @click.stop="close">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
                <button v-if="canPrev" class="fm-lightbox-nav fm-lightbox-nav--prev" @click.stop="prev">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
                </button>
                <img :src="currentSrc" :alt="currentName" class="fm-lightbox-img" @click.stop/>
                <button v-if="canNext" class="fm-lightbox-nav fm-lightbox-nav--next" @click.stop="next">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 6 15 12 9 18"/></svg>
                </button>
                <div class="fm-lightbox-filename" @click.stop>{{ currentName }}</div>
            </div>
        </transition>
    </teleport>
</template>

<script>
import fileManagerService from './fileManagerService'

const IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico']

export default {
    name: 'FileManagerLightbox',
    props: {
        file: { type: Object, default: null },
    },
    emits: ['close', 'navigate'],
    computed: {
        visible() {
            return !!this.file
        },
        imageFiles() {
            return fileManagerService.currentFiles.value.filter(
                f => IMAGE_EXTS.includes((f.extension || '').toLowerCase())
            )
        },
        currentIndex() {
            if (!this.file) return -1
            return this.imageFiles.findIndex(f => f.id === this.file.id)
        },
        currentSrc() {
            return this.file?.thumbnailUrl || this.file?.publicUrl || ''
        },
        currentName() {
            return this.file?.name || ''
        },
        canPrev() {
            return this.currentIndex > 0
        },
        canNext() {
            return this.currentIndex >= 0 && this.currentIndex < this.imageFiles.length - 1
        },
    },
    watch: {
        visible(v) {
            if (v) this.$nextTick(() => this.$refs.lightbox?.focus())
        },
    },
    methods: {
        close() {
            this.$emit('close')
        },
        prev() {
            if (!this.canPrev) return
            this.$emit('navigate', this.imageFiles[this.currentIndex - 1])
        },
        next() {
            if (!this.canNext) return
            this.$emit('navigate', this.imageFiles[this.currentIndex + 1])
        },
        onKeyDown(e) {
            if (e.key === 'Escape') this.close()
            else if (e.key === 'ArrowLeft') this.prev()
            else if (e.key === 'ArrowRight') this.next()
        },
    },
}
</script>
